import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getOtherPodcastList = async (excludeId = null) => {
  let url = `${backendUrl}/api/alpha/last-podcast-list/`;
  if (excludeId !== null) {
    url += `?exclude_id=${encodeURIComponent(excludeId)}`;
  }

  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении списка подкастов: HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения списка подкастов:', error);
    throw error;
  }
};